import { toNormalCase } from "@/lib/utils";

const formatDocsStatus = (status: string): string => {
  if (!status) return "";

  const normalizedStatus = status.toLowerCase();
  if (normalizedStatus === "notrequired") return "N/A";
  if (normalizedStatus === "complete") return "Received";

  return toNormalCase(status);
};

export const formatPipelineItem = <T extends Record<string, unknown>>(item: T): T => {
  return {
    ...item,
    ...(typeof item.customerName === "string" && {
      customerName: toNormalCase(item.customerName),
    }),
    ...(typeof item.dealerDocsStatus === "string" && {
      dealerDocsStatus: formatDocsStatus(item.dealerDocsStatus),
    }),
    ...(typeof item.customerDocsStatus === "string" && {
      customerDocsStatus: formatDocsStatus(item.customerDocsStatus),
    }),
    ...(typeof item.financeDocsStatus === "string" && {
      financeDocsStatus: formatDocsStatus(item.financeDocsStatus),
    }),
  };
};

export const formatPipelineData = <T extends Record<string, unknown>>(data: T): T => {
  const formatArray = <U extends Record<string, unknown>>(arr: U[] | undefined): U[] => {
    return arr?.map(formatPipelineItem) ?? [];
  };

  return {
    ...data,
    ...(Array.isArray(data.valCalls) && {
      valCalls: formatArray(data.valCalls),
    }),
    ...(Array.isArray(data.wip) && {
      wip: formatArray(data.wip),
    }),
    ...(Array.isArray(data.warm) && {
      warm: formatArray(data.warm),
    }),
    ...(Array.isArray(data.customers) && {
      customers: formatArray(data.customers),
    }),
    ...(Array.isArray(data.deals) && {
      deals: formatArray(data.deals),
    }),
  };
};
